<template>
   <l-map style="height: 400px;" :zoom="17" :center="[latitude, longitude]">
    <l-tile-layer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    ></l-tile-layer>
    <l-marker :lat-lng="[latitude, longitude]"></l-marker>
  </l-map>
</template>

<script>
  import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
  import 'leaflet/dist/leaflet.css';
  import L from "leaflet";

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  export default {
    name: 'MapComponent',
    components: {
      LMap,
      LTileLayer,
      LMarker
    },
    props: {
      latitude: {
        type: Number,
        required: true,
      },
      longitude: {
        type: Number,
        required: true,
      },
    },
    mounted() {
      // Inicializar o mapa
      const map = L.map('map').setView([this.latitude, this.longitude], 13);

      // Adicionar o tile layer (camadas do mapa)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(map);

      // Adicionar um marcador nas coordenadas fornecidas
      L.marker([this.latitude, this.longitude]).addTo(map)
        .bindPopup('Coordenada atual')
        .openPopup();
    }
  }
</script>